import { cents } from "byzantine";
import filters from "byzantine/src/filters";

export const DIALOG_PAGE_SIZE = 5;

export const getDialogWidth = ({
  m,
  l,
}: {
  m: boolean;
  l: boolean;
}): string => {
  if (l) return "1080px";
  if (m) return "800px";
  return "90vw";
};

export const formatPaymentAmount = ({
  amount,
  isCollect,
  achPaymentsCollectFeature,
}: {
  amount: number;
  isCollect: boolean;
  achPaymentsCollectFeature: boolean;
}): string => {
  if (amount === 0) {
    return "";
  }
  const formatted = filters.currency(cents(amount));
  if (achPaymentsCollectFeature) {
    return isCollect ? `+${formatted}` : `-${formatted}`;
  }
  return formatted;
};
